import React from 'react'
import {
  Tabs,
  Tab,
  Button,
  FilterWrapper,
  FilterSelector,
  FilterSearch,
  FilterBar
} from 'camino-react'
import _ from 'lodash'

const AlertTableHeaderComponent = ({
  tabs,
  initialFilterOptions,
  addFilter,
  filterText,
  searchFilter,
  searchText,
  filters,
  selectAll,
  data
}) => (
  <>
    <div className="flex flex--space-between">
      {_.some(tabs) && (
        <Tabs>
          {_.map(tabs, tab => (
            <Tab key={tab.text} {...tab}>
              {tab.text}
            </Tab>
          ))}
        </Tabs>
      )}
      {_.find(tabs, tab => (tab.selected)) && _.find(tabs, tab => tab.selected).text === 'Pending' && (
        <Button color="link" onClick={() => selectAll(data)}>
          select all
        </Button>
      )}
    </div>
    <FilterWrapper>
      <FilterSelector
        options={initialFilterOptions}
        addFilter={addFilter}
        text={filterText}
      />
      <FilterSearch filter={searchFilter} placeholder={searchText} />
    </FilterWrapper>

    <FilterBar filters={filters} />
  </>
)
export default AlertTableHeaderComponent
